import styled from 'styled-components';
import Modal from './Modal';
import { colorSchema, media } from 'utils/style';

export default styled(Modal)`
  .modal {
    &__overlay {
      background-color: ${colorSchema('grey900')};
      opacity: 0.8;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 7;
      width: 100vw;
      height: 100vh;
    }

    &__wrapper {
      align-items: center;
      display: flex;
      justify-content: center;
      height: 100%;
      left: 0;
      position: fixed;
      top: 0;
      overflow-x: hidden;
      overflow-y: auto;
      outline: 0;
      width: 100%;
      z-index: 8;
    }

    &__container {
      background: ${colorSchema('white')};
      border-radius: 16px;
      padding: 2.4rem 3.2rem;
      position: relative;
      margin: 0 0.8rem;

      ${media.greaterThan('tablet')`
        margin: 0;
      `}
    }

    &__close {
      background: none;
      border: 0;
      cursor: pointer;
      margin: 0;
      position: absolute;
      right: 2.4rem;
      top: 2.4rem;

      svg {
        fill: ${colorSchema('grey500')};
      }
    }
  }
`;
